import axios from 'Axios';
import {
  SLIP_ENDPOINT,
  allSlipsForTicketRoute,
  singleSlipRoute,
  discardSlipRoute,
  rateSlipRoute,
  shortlistSlipRoute,
  addQuantitiesToSlipRoute,
  getCircularEconomyRoute,
  putSlipStateRoute,
} from '../api/Routes';
import { getProjects } from './projectActions';
import { getCurrentProject } from './ticketActions';

function putSlipStateStart() {
  return {
    type: 'PUT_SLIP_STATE_START',
  };
}
function putSlipStateDone(slipId) {
  return {
    type: 'PUT_SLIP_STATE_DONE',
    slipId: slipId,
  };
}
function getSlipStart() {
  return {
    type: 'GET_SLIP_START',
  };
}
function getSlipDone(data) {
  return {
    type: 'GET_SLIP_DONE',
    currentSlip: data,
  };
}
function getCircularEconomyStart() {
  return {
    type: 'GET_ECONOMIES_START',
  };
}
function getCircularEconomyDone(data) {
  return {
    type: 'GET_ECONOMIES_DONE',
    currentEcon: data,
  };
}
function getAllSlipsStart() {
  return {
    type: 'GET_ALL_SLIPS_START',
  };
}
function getAllSlipsDone(data) {
  return {
    type: 'GET_ALL_SLIPS_DONE',
    slips: data,
  };
}
function shortlistSlipStart() {
  return {
    type: 'SHORTLIST_SLIP_START',
  };
}
function shortlistSlipDone(slipId) {
  return {
    type: 'SHORTLIST_SLIP_DONE',
  };
}
function discardSlipStart() {
  return {
    type: 'DISCARD_SLIP_START',
  };
}
function discardSlipDone(slipId) {
  return {
    type: 'DISCARD_SLIP_DONE',
  };
}
function rateSlipStart() {
  return {
    type: 'RATE_SLIP_START',
  };
}
function rateSlipDone(slipId) {
  return {
    type: 'RATE_SLIP_DONE',
  };
}
function addQuantitiesToCurrentSlipStart() {
  return {
    type: 'RATE_SLIP_START',
  };
}
function addQuantitiesToCurrentSlipDone(slipId) {
  return {
    type: 'RATE_SLIP_DONE',
  };
}
export function rateSlipUpdatedReset(slipId) {
  return {
    type: 'RATE_SLIP_UPDATED_RESET',
  };
}
function slipError(errorMessage) {
  return {
    type: 'SLIP_ERROR',
    errorMessage,
  };
}

export const putSlipState = slipId => {
  return function(dispatch) {
    dispatch(putSlipStateStart());
    axios
      .put(putSlipStateRoute(slipId))
      .then(response => {
        // If request is good...
        const { status, statusText } = response;

        if (status >= 200 && status < 300) return response.data;

        let error = new Error(statusText);
        error.status = status;
        error.promise = response;
        throw error;
      })
      .then(data => {
        dispatch(putSlipStateDone(data));
      })
      .catch(error => {
        // Error
        let errorMessage;
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          errorMessage = error.request;
        } else {
          errorMessage = error.message;
        }
        dispatch(slipError(errorMessage));
      });
  };
};

export const getCurrentSlip = (slipId, projectId) => {
  return function(dispatch) {
    dispatch(getSlipStart());

    axios
      .get(singleSlipRoute(slipId))
      .then(response => {
        // If request is good...
        const { status, statusText } = response;

        if (status >= 200 && status < 300) return response.data;

        let error = new Error(statusText);
        error.status = status;
        error.promise = response;
        throw error;
      })
      .then(data => {
        dispatch(getSlipDone(data));
        dispatch(getProjects());
        if (projectId) dispatch(getCurrentProject(projectId));
      })
      .catch(error => {
        // Error
        let errorMessage;
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          errorMessage = error.request;
        } else {
          errorMessage = error.message;
        }
        dispatch(slipError(errorMessage));
      });
  };
};

export const getCircularEconomy = slipId => {
  return function(dispatch) {
    dispatch(getCircularEconomyStart());
    axios
      .get(getCircularEconomyRoute(slipId))
      .then(res => {
        if (res.status >= 200 && res.status < 300) return res.data;
        let error = new Error(res.statusText);
        error.status = status;
        error.promise = res;
        throw error;
      })
      .then(data => {
        dispatch(getCircularEconomyDone(data));
      });
  };
};

export const getAllSlips = ticketId => {
  return function(dispatch) {
    dispatch(getAllSlipsStart());

    axios
      .get(allSlipsForTicketRoute(ticketId))
      .then(response => {
        // If request is good...
        const { status, statusText } = response;

        if (status >= 200 && status < 300) return response.data;

        let error = new Error(statusText);
        error.status = status;
        error.promise = response;
        throw error;
      })
      .then(data => {
        dispatch(getAllSlipsDone(data));
      })
      .catch(error => {
        // Error
        let errorMessage;
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          errorMessage = error.request;
        } else {
          errorMessage = error.message;
        }
        dispatch(slipError(errorMessage));
      });
  };
};
export const shortlistCurrentSlip = (
  slipId,
  slipObject,
  shortlisted,
  history,
  ticketId,
  projectId
) => {
  return function(dispatch) {
    dispatch(shortlistSlipStart());
    axios
      .put(shortlistSlipRoute(slipId), slipObject)
      .then(response => {
        // If request is good...
        const { status, statusText } = response;

        if (status >= 200 && status < 300) return response.data;

        let error = new Error(statusText);
        error.promise = response;
        throw error;
      })
      .then(() => {
        dispatch(getCurrentSlip(slipId));
        dispatch(shortlistSlipDone());
        !shortlisted &&
          dispatch(
            rateCurrentSlip(slipId, slipObject, history, ticketId, projectId)
          );
        // ? dispatch(
        //     addQuantitiesToCurrentSlip(
        //       slipId,
        //       slipObject,
        //       history,
        //       ticketId,
        //       projectId
        //     )
        //   )
        // : dispatch(
        //     rateCurrentSlip(slipId, slipObject, history, ticketId, projectId)
        //   );

        history.push({
          pathname: `/demand/project/${projectId}/ticket/${ticketId}/slips`,
          state: { slipUpdated: true },
        });
      })
      .catch(error => {
        // Error
        let errorMessage;
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          errorMessage = error.request;
        } else {
          errorMessage = error.message;
        }
        dispatch(slipError(errorMessage));
      });
  };
};
export const discardCurrentSlip = (slipId, history, ticketId, projectId) => {
  return function(dispatch) {
    dispatch(discardSlipStart());

    axios
      .put(discardSlipRoute(slipId), {})
      .then(response => {
        // If request is good...
        const { status, statusText } = response;

        if (status >= 200 && status < 300) return response.data;

        let error = new Error(statusText);
        error.status = status;
        error.promise = response;
        throw error;
      })
      .then(() => {
        dispatch(discardSlipDone());
        history.push({
          pathname: `/demand/project/${projectId}/ticket/${ticketId}/slips`,
          state: { slipUpdated: true },
        });
      })
      .catch(error => {
        // Error
        let errorMessage;
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          errorMessage = error.request;
        } else {
          errorMessage = error.message;
        }
        dispatch(slipError(errorMessage));
      });
  };
};
export const rateCurrentSlip = (
  slipId,
  slipObject,
  history,
  ticketId,
  projectId
) => {
  return function(dispatch) {
    dispatch(rateSlipStart());

    axios
      .put(rateSlipRoute(slipId), slipObject)
      .then(response => {
        // If request is good...
        const { status, statusText } = response;

        if (status >= 200 && status < 300) return response.data;

        let error = new Error(statusText);
        error.status = status;
        error.promise = response;
        throw error;
      })
      .then(() => {
        dispatch(getCurrentSlip(slipId));
        dispatch(rateSlipDone());
        history.push({
          pathname: `/demand/project/${projectId}/ticket/${ticketId}/slips`,
          state: { slipUpdated: true },
        });
      })
      .catch(error => {
        // Error
        let errorMessage;
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          errorMessage = error.request;
        } else {
          errorMessage = error.message;
        }
        dispatch(slipError(errorMessage));
      });
  };
};

export const addQuantitiesToCurrentSlip = (
  slipId,
  slipObject,
  history,
  ticketId,
  projectId
) => {
  return function(dispatch) {
    dispatch(addQuantitiesToCurrentSlipStart());

    axios
      .post(addQuantitiesToSlipRoute(slipId), slipObject)
      .then(response => {
        // If request is good...
        const { status, statusText } = response;

        if (status >= 200 && status < 300) return response.data;

        let error = new Error(statusText);
        error.status = status;
        error.promise = response;
        throw error;
      })
      .then(() => {
        dispatch(addQuantitiesToCurrentSlipDone());
        history.push({
          pathname: `/demand/project/${projectId}/ticket/${ticketId}/slips`,
          state: { slipUpdated: true },
        });
      })
      .catch(error => {
        // Error
        let errorMessage;
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          errorMessage = error.request;
        } else {
          errorMessage = error.message;
        }
        dispatch(slipError(errorMessage));
      });
  };
};

export const getFile = (fileUrl, fileName) => {
  axios
    .get({
      url: fileUrl,
      method: 'GET',
      responseType: 'blob', // important
    })
    .then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName); //or any other extension
      document.body.appendChild(link);
      link.click();
    })
    .catch(error => {
      // Error
      let errorMessage;
      if (error.response) {
        errorMessage = error.response.data.message;
      } else if (error.request) {
        errorMessage = error.request;
      } else {
        errorMessage = error.message;
      }
    });
};
